
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import SelectProduto from "@/shared/components/select-produto.vue";
import {
  PaginaRevista,
  ProdutoPaginaRevista,
  RevistasService,
} from "@/services/revistas.service";
import { Produto } from "@/services/produtos.service";
import InputMoeda from "@/shared/components/input-moeda.vue";
import FormProdutoPagina from "./FormProdutoPagina.vue";
import { EstadoEntidade } from "@/shared/enumeradores";

@Component({
  components: {
    Loading,
    Modal,
    SelectProduto,
    InputMoeda,
    FormProdutoPagina,
  },
})
export default class AdicionarProdutoPaginaRevista extends Vue {
  @Prop() idCatalogo!: string;
  loading = false;
  idRevista = "";
  idPaginaRevista = "";
  paginaRevista = {} as PaginaRevista;
  produtoSelecionado: Produto | null = null;
  produtoPaginaRevista: ProdutoPaginaRevista | null = null;

  @Watch("produtoSelecionado")
  onChange() {
    if (this.produtoSelecionado) {
      this.produtoPaginaRevista = {} as ProdutoPaginaRevista;
      this.produtoPaginaRevista.valor = this.produtoSelecionado.valorVenda!;
      this.produtoPaginaRevista.valorPromocional = this.produtoSelecionado.valorVenda!;
      this.produtoPaginaRevista.descricao = this.produtoSelecionado.descricao!;
      this.produtoPaginaRevista.idProduto = this.produtoSelecionado.idProduto!;
      this.produtoPaginaRevista.estadoEntidade = EstadoEntidade.Nova;
      this.produtoPaginaRevista.idPaginaRevista = this.idPaginaRevista;
    } else {
      this.produtoPaginaRevista = null;
    }
  }
  produtoAtualizado() {
    this.produtoSelecionado = null;
  }
  public async abrirModal(idRevista: string, idPaginaRevista: string) {
    this.idRevista = idRevista;
    this.idPaginaRevista = idPaginaRevista;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.paginaRevista = await RevistasService.obterPaginaRevista(
      idRevista,
      idPaginaRevista
    );
    this.loading = false;

    return p;
  }
  fechar() {
    const modal = this.$refs.modal as Modal;
    this.produtoSelecionado = null;
    modal.close(false);
  }
}
